var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 32,
    viewBox: "0 0 140 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.396 2.0927H13.9766L16.0384 0H132.458V20.4201L137.082 15.7338H139.999L130.396 25.4713V2.0927Z",
    fill: "url(#paint0_linear_633_20859)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60266 29.9073H126.023L123.961 32H7.54115V11.5798L2.91694 16.2661H0L9.60266 6.52869V29.9073Z",
    fill: "url(#paint1_linear_633_20859)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.172 9.38977L95.6037 18.2522V22.6152H93.5399V18.2522L87.9688 9.38977H90.4163L94.5705 16.0011L98.7273 9.38977H101.172Z",
    fill: "#5A5F72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5104 9.38245V22.6201H83.4463V11.2127H83.113L77.3047 22.6201H73.5195V9.39475H75.581V20.7922H75.9169L81.7229 9.38245H85.5104Z",
    fill: "#5A5F72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2448 9.38977V11.2201H38.7285V22.6152H36.6644V11.2201H32.1484V9.38977H43.2448Z",
    fill: "#5A5F72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9563 15.7996H62.4951V11.225H66.9563C68.059 11.225 68.9532 12.2484 68.9532 13.5123C68.9532 14.7762 68.059 15.7996 66.9563 15.7996ZM66.9563 9.39476H62.4951V9.38977H60.4336V22.6152H62.4951V17.6275H66.9563V17.6299C69.1975 17.6299 71.0173 15.7873 71.0173 13.5123C71.0173 11.2397 69.1975 9.39476 66.9563 9.39476Z",
    fill: "#5A5F72"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0185 21.0741C48.3387 21.0741 46.1666 18.8038 46.1666 16.0013C46.1666 13.2012 48.3387 10.9305 51.0185 10.9305C53.6963 10.9305 55.868 13.2012 55.868 16.0013C55.868 18.8038 53.6963 21.0741 51.0185 21.0741ZM51.0185 9.10059C47.1999 9.10059 44.1055 12.1897 44.1055 16.0013C44.1055 19.8125 47.1999 22.9044 51.0185 22.9044C54.8374 22.9044 57.9318 19.8125 57.9318 16.0013C57.9318 12.1897 54.8374 9.10059 51.0185 9.10059Z",
    fill: "#5A5F72"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.189 9.38245V22.6201H117.125V11.2127H117.043L112.393 20.435H110.331L105.681 11.2127H105.597V22.6201H103.535V9.38245H107.203L111.362 18.184L115.521 9.38245H119.189Z",
    fill: "#5A5F72"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2627 20.7971H22.8786V16.1859H27.2627C28.3654 16.1859 29.2596 17.2117 29.2596 18.4732C29.2596 19.7371 28.3654 20.7971 27.2627 20.7971ZM22.8786 11.208H26.2344C26.9511 11.208 27.531 11.9127 27.531 12.7828C27.531 13.6509 26.9511 14.3557 26.2344 14.3557H22.8786V11.208ZM28.9791 14.7421C29.3649 14.188 29.5928 13.5122 29.5928 12.7828C29.5928 10.9016 28.0896 9.37769 26.2344 9.37769H20.8145V22.6274H27.2627C29.5043 22.6274 31.3237 20.7485 31.3237 18.4732C31.3237 16.8229 30.3646 15.3984 28.9791 14.7421Z",
    fill: "#5A5F72"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_633_20859",
    x1: -83.9089,
    y1: -33.49,
    x2: -52.4095,
    y2: -101.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498537,
    stopColor: "#69D2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68AD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_633_20859",
    x1: -97.8854,
    y1: -26.9613,
    x2: -66.386,
    y2: -94.6464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498537,
    stopColor: "#69D2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68AD65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d0481d9e.svg";
export { ForwardRef as ReactComponent };